import camelcaseKeys from "camelcase-keys";
import {
  onAddSubscription,
  onCancelDowngradeSubscription,
  onDeleteSubscription,
  onGetAllSubscriptions,
  onGetSubscriptionDetail,
  onGetSubscriptionsPage,
  onGetUseSubscription,
  onSelectSubscription,
  onUpdateSubscription,
} from "services/apis/subscriptions";
import snakecaseKeys from "snakecase-keys";

import { getWorkspaceInfo } from "./workspace";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

// Sign Up
export const doCreateSubscription = createAsyncThunk(
  "subscriptions/doCreateSubscription",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await onAddSubscription(request);
    if (!result) {
      return;
    }
    dispatch(doGetSubscriptionAll());
    return result.data;
  }
);

export const doUpdateSubscription = createAsyncThunk(
  "subscriptions/doUpdateSubscription",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await onUpdateSubscription(request);
    if (!result) {
      return;
    }
    if (result.status === 200) {
      dispatch(doGetSubscriptionDetail(params.id));
    }
    dispatch(doGetSubscriptionAll());
    return result.data;
  }
);

export const doDeleteSubscription = createAsyncThunk(
  "subscriptions/doDeleteSubscription",
  async (params, { dispatch }) => {
    const result = await onDeleteSubscription(params);
    if (!result) {
      return;
    }
    dispatch(doGetSubscriptionAll());
    return result.data;
  }
);

export const doGetSubscriptionPage = createAsyncThunk(
  "subscriptions/doGetSubscriptionPage",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onGetSubscriptionsPage(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doGetSubscriptionAll = createAsyncThunk(
  "subscriptions/doGetSubscriptionAll",
  async params => {
    const result = await onGetAllSubscriptions(params);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const doGetSubscriptionDetail = createAsyncThunk(
  "subscriptions/doGetSubscriptionDetail",
  async params => {
    const result = await onGetSubscriptionDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doSelectSubscription = createAsyncThunk(
  "subscriptions/doSelectSubscription",
  async params => {
    const request = snakecaseKeys(params);
    const result = await onSelectSubscription(request);
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const doGetUseSubscription = createAsyncThunk(
  "subscriptions/doGetUseSubscription",
  async (param, { dispatch }) => {
    const result = await onGetUseSubscription(param);
    if (!result) {
      return;
    }
    dispatch(getWorkspaceInfo(result.data.workspaceId));

    return camelcaseKeys(result.data);
  }
);

export const doCancelDowngradeSubscription = createAsyncThunk(
  "subscriptions/doCancelDowngradeSubscription",
  async (param, { dispatch }) => {
    const result = await onCancelDowngradeSubscription(snakecaseKeys(param));
    if (!result) {
      return;
    }
    // dispatch(getWorkspaceInfo(result.data.workspaceId));
    dispatch(doGetUseSubscription(param.workspaceId));
    return camelcaseKeys(result.data);
  }
);

const initialState = {
  isSaving: false,
  isLoading: false,
  subscriptionList: [],
  subscriptions: [],
  subscriptionDetail: {},
  pagination: {
    page: 1,
    size: 10,
  },
  cloneSubscription: {},
  currentSubscription: {},
};

const slice = createSlice({
  name: "subscriptions",
  initialState: initialState,
  reducers: {
    clearSubscriptionDetail: state => {
      state.subscriptionDetail = {};
    },
    clearSubscriptionList: state => {
      state.subscriptions = [];
    },
    copySubscription: (state, action) => {
      const { payload } = action;
      state.cloneSubscription = { ...payload };
    },
  },
  extraReducers: {
    [doGetSubscriptionAll.pending]: state => {
      state.isLoading = true;
    },
    [doGetSubscriptionAll.fulfilled]: (state, action) => {
      const { payload } = action;
      state.isLoading = false;
      if (typeof payload === "object") {
        state.subscriptions = [...payload];
      }
    },
    [doGetSubscriptionAll.rejected]: state => {
      state.isLoading = false;
      state.subscriptions = [];
    },
    [doGetSubscriptionDetail.fulfilled]: (state, action) => {
      const { payload } = action;
      state.subscriptionDetail = { ...payload };
    },
    [doGetUseSubscription.fulfilled]: (state, action) => {
      const { payload } = action;
      state.currentSubscription = { ...payload };
    },
    [doCancelDowngradeSubscription.pending]: state => {
      state.isLoading = true;
    },
    [doCancelDowngradeSubscription.fulfilled]: state => {
      state.isLoading = false;
    },
    [doCancelDowngradeSubscription.rejected]: state => {
      state.isLoading = false;
    },
  },
});

const { reducer, actions } = slice;
export const {
  clearSubscriptionDetail,
  copySubscription,
  clearSubscriptionList,
} = actions;
export default reducer;

export const getIsLoading = createSelector(
  state => state.subscriptions.isLoading,
  isLoading => isLoading
);

export const isSaving = createSelector(
  state => state.subscriptions.isSaving,
  isSaving => isSaving
);

export const getAllSubscriptions = createSelector(
  state => state.subscriptions.subscriptions,
  subscriptions => subscriptions
);

export const getSubscriptionDetail = createSelector(
  state => state.subscriptions.subscriptionDetail,
  subscriptionDetail => subscriptionDetail
);

export const getCloneSubscription = createSelector(
  state => state.subscriptions.cloneSubscription,
  cloneSubscription => cloneSubscription
);

export const getCurrentSubscription = createSelector(
  state => state.subscriptions.currentSubscription,
  currentSubscription => currentSubscription
);
